import { StatusBanner, Span, CdnIcon } from '@pcln/horizon'

export default function GenericErrorBanner() {
  return (
    <StatusBanner
      headingNode={
        <Span textStyle="body2" bold>
          Uh oh! Something went wrong with your search.{' '}
          <Span style={{ fontWeight: 'normal' }}>Please try again.</Span>
        </Span>
      }
      palette="caution"
      iconNode={<CdnIcon iconName="error" />}
    />
  )
}
